window.onload = function () {

    var winheight, docheight, docwidth, trackLength;

    function getmeasurements() {
        winheight = window.innerHeight;
        docheight = document.body.clientHeight;
        docwidth = document.body.clientWidth;
        trackLength = docheight - winheight;
    }

    function amountscrolled() {
        var scrollTop = window.pageYOffset || (document.body.parentNode || document.body).scrollTop;

        var amount = Math.floor(scrollTop / trackLength * 100);

        if (amount >= 23)
            $('.stickyquotebutton').css('right', '0');
        else
            $('.stickyquotebutton').css('right', '-4%');
    }


    if ($('.stickyquotebutton').length > 0) {
        getmeasurements();
        amountscrolled();

        window.addEventListener('resize', function () {
            getmeasurements();
        }, false);

        window.addEventListener('scroll', function () {
            setTimeout(function () {
                amountscrolled();
            }, 10);
        }, false);
    }
};

$(function() {
    // Jump to Article Sliding Animation
    $('.stickyquotebutton').on('click', function () {
        $('html, body').animate({
            scrollTop: 0
        }, 1000);
    });
});